{
  "fr": {
    "actions": {
      "announcements": {
        "addPart": "Ajouter",
        "removePart": "Retirer",
        "movePartUp": "Monter",
        "movePartDown": "Descendre",
        "sendTest": "Envoyer un test",
        "publish": "Envoyer",
        "retry": "Réessayer",
        "refreshEngagement": "Actualiser les chiffres",
        "openPost": "Ouvrir la publication"
      },
      "admin": {
        "dashboard": {
          "reloadModels": "Recharger les modèles",
          "reloadScData": "Recharger les données SC",
          "reloadPaints": "Recharger les peintures",
          "reloadModules": "Recharger les modules",
          "reloadLoaners": "Recharger les prêts"
        },
        "supporterContributions": {
          "syncFromPatreon": "Synchroniser depuis Patreon"
        },
        "imports": {
          "loadAll": "Tout charger",
          "load": "Charger",
          "loadScData": "Charger les données SC",
          "loadShipMatrix": "Charger la ship matrix",
          "cleanup": "Marquer comme échouée",
          "cleanupSelected": "Marquer la sélection comme échouée"
        }
      },
      "duplicate": "Dupliquer",
      "upgrade": "Une mise à jour est disponible !",
      "backToHome": "Planifier un nouveau voyage",
      "disableGrouping": "Désactiver le groupement",
      "enableGrouping": "Désactiver le groupement",
      "groupedByModel": "Grouper par modèle",
      "destroyAccount": "Supprimer le compte",
      "saveScreenshot": "Enregistrer au format PNG",
      "resolve": "Résoudre",
      "sortBy": "Trier par",
      "back": "Précédent",
      "open": "Ouvrir",
      "copy": "Copier",
      "download": "Télécharger",
      "zoom": "Zoom",
      "more": "Détails...",
      "export": "Exporter",
      "exportHangarLink": "Exporter vers hangar.link",
      "import": "Importer",
      "here": "ici",
      "previous": "Précédent",
      "next": "Suivant",
      "cancel": "Annuler",
      "ok": "Ok",
      "reset": "Réinitialiser",
      "reload": "Recharger",
      "retry": "Réessayer",
      "confirm": "Valider",
      "showDetailPage": "Détails",
      "showDetails": "Afficher les détails",
      "hideDetails": "Masquer les détails",
      "readMore": "Lire la suite",
      "readLess": "Afficher moins",
      "showGuide": "Afficher le guide",
      "showFleetchart": "Diagramme de flotte",
      "hideFleetchart": "Affichage par défaut",
      "fleetchartApp": {
        "useExtendedState": "Afficher les vaisseaux déployés",
        "useRetractedState": "Afficher les vaisseaux en vol"
      },
      "showLabels": "Afficher les labels",
      "hideLabels": "Masquer les labels",
      "resetZoom": "Réinitialiser le zoom",
      "supportUs": "Soutenir FleetYards.net",
      "installApp": {
        "cta": "Installer l'app",
        "later": "Pas maintenant"
      },
      "supportHint": {
        "cta": "Soutenir FleetYards",
        "later": "Peut-être plus tard"
      },
      "login": "Se connecter",
      "signUp": "Créer un compte",
      "confirmAccess": "Confirmer le mot de passe",
      "sendConfirmAccessEmail": "Envoyer l'e-mail de confirmation",
      "reset-password": "Mot de passe oublié ?",
      "edit": "Modifier",
      "clear": "Effacer",
      "done": "Terminer",
      "share": "Partager",
      "change": "Modifier",
      "upload": "Charger",
      "save": "Sauvegarder",
      "enable": "Activer",
      "disable": "Désactiver",
      "manage": "Gérer",
      "enableGlobally": "Activer globalement",
      "disableGlobally": "Désactiver globalement",
      "addActor": "Ajouter un acteur",
      "addGroup": "Ajouter un groupe",
      "editGroup": "Modifier le groupe",
      "remove": "Retirer",
      "reorder": "Réordonner",
      "moveUp": "Monter",
      "moveDown": "Descendre",
      "delete": "Supprimer",
      "deleteSelected": "Supprimer la sélection",
      "enableSelected": "Activer la sélection",
      "disableSelected": "Désactiver la sélection",
      "presets": {
        "choose": "Choisir une image",
        "remove": "Retirer l'image"
      },
      "close": "Fermer",
      "filter": "Filtrer",
      "showStatusColor": "Afficher l'état en tant que couleur",
      "hideStatusColor": "Masquer le statut en tant que couleur",
      "addToHangar": "Ajouter à votre Hangar",
      "blueprint": {
        "own": "Marquer comme possédé",
        "unown": "Retirer la marque"
      },
      "resetFilter": "Réinitialiser les filtres",
      "requestPassword": "Demande de mot de passe par e-mail",
      "changePassword": "Modifier le mot de passe",
      "updatePassword": "Changer le mot de passe",
      "copyBackupCodes": "Copier les codes de sauvegarde",
      "regenerate": "Régénérer",
      "add": "Ajouter",
      "create": "Créer",
      "addToWishlist": "Ajouter à la liste de souhaits",
      "addVehicle": "Ajouter un vaisseau",
      "showTableView": "Afficher sous forme de liste",
      "showGridView": "Afficher sous forme de grille",
      "linkExisting": "Lier existant",
      "loadMore": "Charger plus",
      "unlink": "Délier",
      "syncRsiHangar": "Synchroniser le hangar RSI",
      "oauthApplications": {
        "create": "Nouvelle application",
        "regenerateSecret": "Régénérer le secret",
        "approve": "Approuver",
        "reject": "Refuser",
        "rejectSelected": "Refuser la sélection"
      },
      "oauthAuthorize": {
        "authorize": "Autoriser",
        "deny": "Refuser"
      },
      "verifyWithCitizenId": "Vérifier avec Citizen iD",
      "user": {
        "rsiVerification": {
          "verify": "Vérifier via le profil RSI",
          "check": "Vérifier maintenant",
          "checkIn": "Revérifier dans %{seconds} s",
          "copyToken": "Copier le code",
          "regenerateToken": "Générer un nouveau code",
          "revoke": "Révoquer"
        }
      },
      "oauth": {
        "signInWith": "Se connecter avec",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "Connecté à Google",
          "discord": "Connecté à Discord",
          "bluesky": "Connecté à BlueSky",
          "github": "Connecté à GitHub",
          "twitch": "Connecté à Twitch",
          "citizenid": "Connecté à Citizen iD",
          "patreon": "Connecté à Patreon"
        },
        "disconnect": {
          "google": "Déconnecter Google",
          "discord": "Déconnecter Discord",
          "bluesky": "Déconnecter BlueSky",
          "github": "Déconnecter GitHub",
          "twitch": "Déconnecter Twitch",
          "citizenid": "Déconnecter Citizen iD",
          "patreon": "Déconnecter Patreon"
        },
        "patreon": "Patreon"
      },
      "compare": {
        "ships": "Comparer"
      },
      "cargoGrids": {
        "addShips": "Ajouter des vaisseaux"
      },
      "tradeRoutes": {
        "pickShip": "Choisir un vaisseau",
        "changeShip": "Changer de vaisseau",
        "editRun": "Modifier",
        "doneEditing": "Terminé",
        "backToRuns": "Retour à tous les trajets",
        "showMore": "Afficher plus de trajets"
      },
      "hangar": {
        "editGroups": "Ajouter ou supprimer des groupes",
        "editName": "Nommez votre vaisseau",
        "manageLoadouts": "Gérer les configurations",
        "manageCargo": "Gérer la cargaison",
        "useName": "Utiliser ce nom",
        "destroyAll": "Supprimer tous les vaisseaux",
        "showOnPublicHangar": "Rendre publique",
        "hideFromPublicHangar": "Rendre privé",
        "editGroupsSelected": "Ajouter/Retirer des groupes",
        "resetIngame": {
          "openModal": "Réinitialiser les vaisseaux obtenus dans le jeu",
          "moveToWishlist": "Déplacer dans la liste de souhaits",
          "removeAll": "Tout supprimer"
        }
      },
      "syncExtension": {
        "cancel": "Annuler",
        "start": "Démarrer la synchronisation",
        "retry": "Réessayer la synchronisation",
        "close": "Fermer",
        "refresh": "Actualiser la page"
      },
      "empty": {
        "hangarGuide": "Besoin d'aide ?",
        "reset": "Effacer les filtres"
      },
      "destroyFleet": "Détruire la flotte",
      "restore": "Restaurer",
      "fleet": {
        "fidClaim": {
          "claim": "Réclamer %{fid}",
          "withdraw": "Retirer la réclamation",
          "useSuggestion": "Utiliser %{suggestion}",
          "endNow": "Terminer le délai de grâce maintenant",
          "cancel": "Annuler la réclamation"
        },
        "rsiVerification": {
          "verify": "Vérifier",
          "regenerateToken": "Générer un nouveau code",
          "check": "Vérifier maintenant",
          "copyToken": "Copier le code",
          "revoke": "Révoquer"
        },
        "join": "Rejoignez la flotte %{fleet}!",
        "leave": "Quitter la flotte %{fleet}",
        "createInviteUrl": "Créer un lien d'invitation",
        "inviteMember": "Inviter un nouveau membre",
        "squadrons": {
          "create": "Créer un escadron",
          "addMember": "Ajouter des membres",
          "removeMember": "Retirer de l'escadron",
          "addMembers": "Ajouter %{count}",
          "viewMembers": "Membres de l'escadron",
          "viewShips": "Vaisseaux de l'escadron",
          "viewStats": "Statistiques de l'escadron",
          "join": "Rejoindre l'équipe",
          "leave": "Quitter",
          "requestJoin": "Demander à rejoindre",
          "withdrawRequest": "Retirer la demande",
          "acceptRequest": "Accepter",
          "declineRequest": "Refuser",
          "promote": "Promouvoir",
          "demote": "Rétrograder"
        },
        "manageInvites": "Invitations",
        "worldmap": "Carte du monde",
        "starmap": "Carte stellaire",
        "acceptInvite": "Accepter l'invitation",
        "declineInvite": "Décliner l'invitation",
        "acceptRequest": "Accepter la demande",
        "declineRequest": "Décliner la demande",
        "members": {
          "invite": "Inviter",
          "promote": "Promouvoir",
          "demote": "Rétrograder",
          "accept": "Accepter",
          "decline": "Décliner",
          "remove": "Retirer",
          "editRole": "Modifier le rôle",
          "editNickname": "Modifier le surnom"
        },
        "inviteUrls": {
          "create": "Créer le nouveau lien d'invitation"
        },
        "discord": {
          "test": "Tester la connexion Discord",
          "installBot": "Installer le bot Fleetyards sur votre serveur Discord"
        },
        "calendarSubscription": {
          "enable": "Générer un lien d'abonnement",
          "rotate": "Renouveler le lien",
          "disable": "Désactiver l'abonnement"
        }
      },
      "model": {
        "gallery": "Galerie",
        "onSale": "En vente : %{price}",
        "store": "Page RSI"
      },
      "models": {
        "sync": "Synchroniser depuis RSI",
        "syncMatrix": "Synchroniser la matrice",
        "syncScData": "Synchroniser les données SC",
        "importPaints": "Importer les peintures",
        "exchangeStoreImage": "Utiliser l'image RSI",
        "images": "Images",
        "openTableConfiguration": "Ouvrir la configuration du tableau"
      },
      "users": {
        "loginAs": "Se connecter en tant qu'utilisateur",
        "resendConfirmation": "Renvoyer la confirmation",
        "sendPasswordReset": "Envoyer la réinitialisation du mot de passe"
      },
      "unselect": "Retirer la sélection",
      "twoFactor": {
        "enable": "Activer l'authentification à deux facteurs",
        "disable": "Désactiver l'authentification à deux facteurs",
        "generateBackupCodes": "Générer des codes de sauvegarde"
      },
      "holoViewer": {
        "autoRotate": {
          "enable": "Activer la rotation automatique",
          "disable": "Désactiver la rotation automatique"
        },
        "zoom": {
          "enable": "Activer le zoom",
          "disable": "Désactiver le zoom"
        },
        "color": {
          "enable": "Activer les couleurs",
          "disable": "Désactiver les couleurs"
        }
      },
      "logistics": {
        "createInventory": "New Inventory",
        "submit": "Submit",
        "reject": "Reject",
        "cancel": "Cancel",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "Vider la cargaison",
        "viewCargoGrid": "Voir la grille de cargaison",
        "sendTransfer": "Envoyer",
        "moveStock": "Déplacer",
        "transfer": "Transférer",
        "acceptTransfer": "Accepter",
        "declineTransfer": "Refuser",
        "cancelTransfer": "Annuler",
        "reportTransfer": "Signaler",
        "resetToMax": "Remettre au maximum",
        "removeLine": "Retirer"
      },
      "adminNotifications": {
        "unread": "Marquer comme non lu",
        "archive": "Archiver",
        "unarchive": "Remettre dans la boîte de réception",
        "readAll": "Tout marquer comme lu",
        "destroyAll": "Tout supprimer",
        "sortOldest": "Les plus anciennes d'abord",
        "sortNewest": "Les plus récentes d'abord",
        "select": "Sélectionner la notification",
        "readSelected": "Marquer la sélection comme lue",
        "unreadSelected": "Marquer la sélection comme non lue",
        "archiveSelected": "Archiver la sélection",
        "unarchiveSelected": "Remettre la sélection dans la boîte de réception",
        "destroySelected": "Supprimer la sélection"
      },
      "account": {
        "calendarSubscription": {
          "enable": "Générer un lien de calendrier personnel",
          "rotate": "Renouveler le lien",
          "disable": "Désactiver l'abonnement"
        }
      },
      "today": "Aujourd'hui",
      "fleets": {
        "missions": {
          "publish": "Publier",
          "create": "Créer une mission",
          "edit": "Modifier la mission",
          "archive": "Archiver la mission",
          "unarchive": "Désarchiver",
          "destroy": "Supprimer définitivement",
          "addTeam": "Ajouter une équipe",
          "addShip": "Ajouter un vaisseau",
          "addSlot": "Ajouter un poste",
          "viewMissions": "Voir les missions"
        },
        "tours": {
          "viewTours": "Voir les tournées"
        },
        "events": {
          "create": "Créer un événement",
          "edit": "Modifier l'événement",
          "spawn": "Créer depuis cette mission",
          "archive": "Archiver l'événement",
          "unarchive": "Restaurer depuis les archives",
          "syncToDiscord": "Synchroniser vers Discord",
          "destroy": "Supprimer définitivement",
          "publish": "Publier",
          "lockSignups": "Verrouiller les inscriptions",
          "unlockSignups": "Déverrouiller les inscriptions",
          "start": "Démarrer",
          "complete": "Terminer",
          "cancel": "Annuler",
          "signup": "S'inscrire",
          "withdraw": "Se désinscrire",
          "kick": "Retirer l'inscription",
          "addToCalendar": "Ajouter au calendrier",
          "subscribe": "S'abonner",
          "setUpCalendar": "Configurer les abonnements calendrier",
          "assignSlot": "Assigner à un poste",
          "reassignSlot": "Déplacer vers un autre poste",
          "manageEventTeam": "Gérer l'équipe de l'événement",
          "grantRole": "Attribuer un rôle",
          "revokeRole": "Révoquer",
          "addTeam": "Ajouter une équipe"
        },
        "contracts": {
          "create": "Créer un contrat",
          "save": "Enregistrer",
          "publish": "Publier",
          "claim": "Prendre",
          "join": "Demander à rejoindre",
          "release": "Abandonner",
          "fulfil": "Marquer comme rempli",
          "cancel": "Annuler le contrat",
          "edit": "Modifier",
          "leave": "Quitter",
          "remove": "Retirer",
          "acceptCrew": "Accepter",
          "declineCrew": "Refuser",
          "addItem": "Ajouter des marchandises",
          "payouts": "Paiements"
        }
      },
      "notifications": {
        "unread": "Marquer comme non lu",
        "archive": "Archiver",
        "unarchive": "Remettre dans la boîte de réception",
        "readAll": "Tout marquer comme lu",
        "destroyAll": "Tout supprimer",
        "settings": "Paramètres de notification",
        "sortOldest": "Les plus anciennes d'abord",
        "sortNewest": "Les plus récentes d'abord",
        "openCenter": "Notifications",
        "pushEnable": "Activer sur cet appareil",
        "pushDisable": "Désactiver sur cet appareil",
        "pushRemove": "Retirer",
        "select": "Sélectionner la notification",
        "readSelected": "Marquer la sélection comme lue",
        "unreadSelected": "Marquer la sélection comme non lue",
        "archiveSelected": "Archiver la sélection",
        "unarchiveSelected": "Remettre la sélection dans la boîte de réception",
        "destroySelected": "Supprimer la sélection"
      },
      "unlistedModel": {
        "createModel": "Créer le vaisseau",
        "markAsPaint": "C'est une peinture",
        "ignore": "Ignorer",
        "noManufacturer": "Aucun constructeur ne correspond à cet identifiant",
        "alreadyExists": "%{name} est déjà dans le catalogue",
        "link": "Déjà dans le catalogue",
        "markAsPaintSelected": "Marquer la sélection comme peintures",
        "ignoreSelected": "Ignorer la sélection"
      },
      "revert": "Rétablir",
      "exportCsv": "Exporter en CSV",
      "exportAllCsv": "Tout exporter en CSV",
      "imports": {
        "cancel": "Annuler",
        "downloadExample": "Fichier d'exemple",
        "toggleDetails": "Voir ce qui s'est passé"
      },
      "selectFile": "Choisir un fichier",
      "applyGameFileValue": "Appliquer",
      "applyAllGameFileValues": "Tout appliquer",
      "payouts": {
        "archiveTour": "Archiver",
        "unarchiveTour": "Restaurer",
        "deleteTour": "Supprimer",
        "openLedger": "Ouvrir le registre",
        "addEntry": "Enregistrer un montant",
        "addParticipant": "Ajouter un participant",
        "settle": "Clôturer et calculer",
        "reopen": "Rouvrir",
        "confirm": "Marquer comme payé",
        "unconfirm": "Marquer comme impayé",
        "createTour": "Créer une expédition",
        "joinTour": "Rejoindre",
        "rotateInvite": "Générer un nouveau lien",
        "askToJoin": "Demander à participer",
        "withdrawJoinRequest": "Retirer la demande",
        "approveJoinRequest": "Accepter",
        "declineJoinRequest": "Refuser",
        "approveExpense": "Approuver",
        "declineExpense": "Refuser"
      },
      "relationships": {
        "accept": "Accepter",
        "decline": "Refuser",
        "ignore": "Ignorer",
        "withdraw": "Retirer",
        "end": "Supprimer",
        "send": "Envoyer la demande",
        "user": {
          "add": "Ajouter un ami"
        },
        "fleet": {
          "add": "Ajouter un allié"
        }
      },
      "supporterNomination": {
        "change": "Changer de flotte"
      }
    }
  }
}
